const Widget = () => {
  return <div>switch language</div>;
};

export default Widget;
